var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGetCredentialsAndDeploy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.890869,
    width: 194.218,
    height: 196,
    rx: 50,
    fill: "#D2BAFF",
    fillOpacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1818,
    y: 44.5454,
    width: 90.8727,
    height: 81.0727,
    rx: 9,
    fill: "#D2BAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3636,
    y: 26.7273,
    width: 96.2182,
    height: 87.3091,
    rx: 9,
    fill: "white",
    stroke: "#A788FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5818 33.9455C60.5818 28.9749 64.6112 24.9455 69.5818 24.9455H151.364C156.334 24.9455 160.364 28.9749 160.364 33.9455V53.4546H60.5818V33.9455Z",
    fill: "#A788FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.8364,
    cy: 39.2,
    r: 4.45455,
    fill: "#7B3DE9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.309,
    cy: 39.2,
    r: 4.45455,
    fill: "#7B3DE9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.7818,
    cy: 39.2,
    r: 4.45455,
    fill: "#7B3DE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5454 70.3818L83.5193 80.8256C83.1478 81.2126 83.1478 81.8237 83.5193 82.2107L93.5454 92.6545",
    stroke: "#A788FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 92.6545L136.535 82.2107C136.907 81.8237 136.907 81.2126 136.535 80.8256L126.509 70.3818",
    stroke: "#A788FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 70.3818L102.455 92.6545",
    stroke: "#A788FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6509 168.215C34.6174 168.789 35.074 169.273 35.6492 169.273H37.3905C37.9647 169.273 38.4209 168.79 38.3889 168.217L38.2072 164.958C38.1618 164.144 39.0571 163.621 39.744 164.06L42.6248 165.9C43.1017 166.205 43.7363 166.053 44.0241 165.566L44.8834 164.112C45.1804 163.609 44.9853 162.96 44.4603 162.704L41.5006 161.263C40.7511 160.898 40.7511 159.83 41.5006 159.465L44.4603 158.023C44.9853 157.767 45.1804 157.118 44.8834 156.615L44.0241 155.161C43.7363 154.674 43.1017 154.522 42.6248 154.827L39.744 156.667C39.0571 157.106 38.1618 156.583 38.2072 155.769L38.3889 152.51C38.4209 151.937 37.9647 151.455 37.3905 151.455H35.6492C35.074 151.455 34.6174 151.939 34.6509 152.513L34.8404 155.763C34.8879 156.578 33.9916 157.104 33.3037 156.664L30.4281 154.827C29.9511 154.522 29.3166 154.674 29.0287 155.161L28.1689 156.616C27.8721 157.119 28.0667 157.768 28.591 158.024L31.5424 159.465C32.2906 159.83 32.2906 160.897 31.5424 161.262L28.591 162.704C28.0667 162.96 27.8721 163.608 28.1689 164.111L29.0287 165.566C29.3166 166.053 29.9511 166.205 30.4281 165.9L33.3037 164.063C33.9916 163.624 34.8879 164.149 34.8404 164.964L34.6509 168.215Z",
    fill: "url(#paint0_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4831 168.215C58.4496 168.789 58.9062 169.273 59.4814 169.273H61.2227C61.7969 169.273 62.2531 168.79 62.2212 168.217L62.0394 164.958C61.994 164.144 62.8893 163.621 63.5763 164.06L66.457 165.9C66.934 166.205 67.5685 166.053 67.8564 165.566L68.7156 164.112C69.0127 163.609 68.8175 162.96 68.2925 162.704L65.3329 161.263C64.5833 160.898 64.5833 159.83 65.3329 159.465L68.2925 158.023C68.8175 157.767 69.0127 157.118 68.7156 156.615L67.8564 155.161C67.5685 154.674 66.934 154.522 66.457 154.827L63.5763 156.667C62.8893 157.106 61.994 156.583 62.0394 155.769L62.2212 152.51C62.2531 151.937 61.7969 151.455 61.2227 151.455H59.4814C58.9062 151.455 58.4496 151.939 58.4831 152.513L58.6726 155.763C58.7201 156.578 57.8239 157.104 57.1359 156.664L54.2603 154.827C53.7833 154.522 53.1488 154.674 52.8609 155.161L52.0011 156.616C51.7043 157.119 51.8989 157.768 52.4232 158.024L55.3746 159.465C56.1228 159.83 56.1228 160.897 55.3746 161.262L52.4232 162.704C51.8989 162.96 51.7043 163.608 52.0011 164.111L52.8609 165.566C53.1488 166.053 53.7833 166.205 54.2603 165.9L57.1359 164.063C57.8239 163.624 58.7201 164.149 58.6726 164.964L58.4831 168.215Z",
    fill: "url(#paint1_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3153 168.215C82.2818 168.789 82.7385 169.273 83.3136 169.273H85.055C85.6291 169.273 86.0854 168.79 86.0534 168.217L85.8717 164.958C85.8263 164.144 86.7215 163.621 87.4085 164.06L90.2893 165.9C90.7662 166.205 91.4007 166.053 91.6886 165.566L92.5479 164.112C92.8449 163.609 92.6497 162.96 92.1247 162.704L89.1651 161.263C88.4156 160.898 88.4156 159.83 89.1651 159.465L92.1247 158.023C92.6497 157.767 92.8449 157.118 92.5479 156.615L91.6886 155.161C91.4007 154.674 90.7662 154.522 90.2893 154.827L87.4085 156.667C86.7215 157.106 85.8263 156.583 85.8717 155.769L86.0534 152.51C86.0854 151.937 85.6291 151.455 85.055 151.455H83.3136C82.7385 151.455 82.2818 151.939 82.3153 152.513L82.5048 155.763C82.5523 156.578 81.6561 157.104 80.9682 156.664L78.0925 154.827C77.6156 154.522 76.981 154.674 76.6932 155.161L75.8333 156.616C75.5365 157.119 75.7311 157.768 76.2555 158.024L79.2068 159.465C79.9551 159.83 79.9551 160.897 79.2068 161.262L76.2555 162.704C75.7311 162.96 75.5365 163.608 75.8333 164.111L76.6932 165.566C76.981 166.053 77.6156 166.205 78.0925 165.9L80.9682 164.063C81.6561 163.624 82.5523 164.149 82.5048 164.964L82.3153 168.215Z",
    fill: "url(#paint2_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.148 168.215C106.114 168.789 106.571 169.273 107.146 169.273H108.887C109.461 169.273 109.918 168.79 109.886 168.217L109.704 164.958C109.659 164.144 110.554 163.621 111.241 164.06L114.121 165.9C114.598 166.205 115.233 166.053 115.521 165.566L116.38 164.112C116.677 163.609 116.482 162.96 115.957 162.704L112.997 161.263C112.248 160.898 112.248 159.83 112.997 159.465L115.957 158.023C116.482 157.767 116.677 157.118 116.38 156.615L115.521 155.161C115.233 154.674 114.598 154.522 114.121 154.827L111.241 156.667C110.554 157.106 109.659 156.583 109.704 155.769L109.886 152.51C109.918 151.937 109.461 151.455 108.887 151.455H107.146C106.571 151.455 106.114 151.939 106.148 152.513L106.337 155.763C106.385 156.578 105.488 157.104 104.8 156.664L101.925 154.827C101.448 154.522 100.813 154.674 100.525 155.161L99.6656 156.616C99.3687 157.119 99.5634 157.768 100.088 158.024L103.039 159.465C103.787 159.83 103.787 160.897 103.039 161.262L100.088 162.704C99.5634 162.96 99.3687 163.608 99.6656 164.111L100.525 165.566C100.813 166.053 101.448 166.205 101.925 165.9L104.8 164.063C105.488 163.624 106.385 164.149 106.337 164.964L106.148 168.215Z",
    fill: "url(#paint3_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.98 168.215C129.946 168.789 130.403 169.273 130.978 169.273H132.719C133.294 169.273 133.75 168.79 133.718 168.217L133.536 164.958C133.491 164.144 134.386 163.621 135.073 164.06L137.954 165.9C138.431 166.205 139.065 166.053 139.353 165.566L140.212 164.112C140.509 163.609 140.314 162.96 139.789 162.704L136.83 161.263C136.08 160.898 136.08 159.83 136.83 159.465L139.789 158.023C140.314 157.767 140.509 157.118 140.212 156.615L139.353 155.161C139.065 154.674 138.431 154.522 137.954 154.827L135.073 156.667C134.386 157.106 133.491 156.583 133.536 155.769L133.718 152.51C133.75 151.937 133.294 151.455 132.719 151.455H130.978C130.403 151.455 129.946 151.939 129.98 152.513L130.169 155.763C130.217 156.578 129.321 157.104 128.633 156.664L125.757 154.827C125.28 154.522 124.646 154.674 124.358 155.161L123.498 156.616C123.201 157.119 123.396 157.768 123.92 158.024L126.871 159.465C127.62 159.83 127.62 160.897 126.871 161.262L123.92 162.704C123.396 162.96 123.201 163.608 123.498 164.111L124.358 165.566C124.646 166.053 125.28 166.205 125.757 165.9L128.633 164.063C129.321 163.624 130.217 164.149 130.169 164.964L129.98 168.215Z",
    fill: "url(#paint4_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.925 170.279) rotate(-171.747) scale(140.837 53.5734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837335,
    stopColor: "#A788FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.925 170.279) rotate(-171.747) scale(140.837 53.5734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837335,
    stopColor: "#A788FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.925 170.279) rotate(-171.747) scale(140.837 53.5734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837335,
    stopColor: "#A788FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.925 170.279) rotate(-171.747) scale(140.837 53.5734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837335,
    stopColor: "#A788FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.925 170.279) rotate(-171.747) scale(140.837 53.5734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837335,
    stopColor: "#A788FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGetCredentialsAndDeploy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/get_credentials_and_deploy.b96da6b49744fb7007da16a6fe9edf58.svg";